module.exports = __webpack_public_path__ + "img/logo.463f88a3.png";